import { Button, Card, Col, Input, List, message, Row } from "antd";
import { FormEvent, useEffect, useState } from "react";
import { getGenericCollection } from "../../services/firestore";
import { Raffle, Ticket } from "../Raffles/interfaces";
import { and, or, where } from "firebase/firestore";
import FullLoader from "../../components/FullLoader/FullLoader";
import { CaretDownOutlined, CheckCircleOutlined, SearchOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const VerifyTickets = () => {
  const [search, setSearch] = useState("");
  const [tickets, setTickets] = useState<Ticket[]>([]);
  const [searching, setSearching] = useState(false);
  const navigate = useNavigate();
  const { state } = useLocation();
  const raffle = state as Raffle | null;

  useEffect(() => {
    if (raffle) return;

    navigate("/");
  }, [raffle]);

  const searchTicket = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!search || !raffle) {
      return;
    }

    try {
      const _tickets = await getGenericCollection<Ticket>(
        "tickets",
        and(
          or(
            where("number", "==", Number(search)),
            where("phone", "==", search)
          ),
          where("raffleId", "==", raffle.id),
          where("status", "!=", "Libre"),
        )
      );

      if (!_tickets.length) {
        message.error("Boletos no encontrados");
        return;
      }

      setTickets(_tickets);
    } catch (error) {
      console.log(error);
    } finally {
      setSearching(false);
    }
  };

  return (
    <div
      style={{
        paddingTop: "15vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "green",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 60,
          width: "100%"
        }}
      >
        <div style={{ fontWeight: "bold", color: "white", fontSize: 30 }}>VERIFICADOR DE BOLETOS</div>
      </div>
      <br />
      <h2 style={{ color: "orangered", fontWeight: "bold", fontSize: 30 }}>
        RIFA: {raffle?.name.toUpperCase()}
      </h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 10,
        }}
      >
        <CaretDownOutlined style={{ fontSize: 40, color: "orangered" }} />
        <div
          style={{
            textAlign: "center"
          }}
        >
          <b style={{ color: "black", fontWeight: "bold", fontSize: 20 }}>
            Introduce tu BOLETO ó CELULAR y haz click en "Verificar"
          </b>
        </div>
        <CaretDownOutlined style={{ fontSize: 40, color: "orangered" }} />
      </div>
      <br />
      <form onSubmit={searchTicket}>
        <div
          style={{
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 10
          }}
        >
          <Input
            value={search}
            type="number"
            placeholder="Boleto o celular"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
            style={{
              fontSize: 18,
              fontWeight: "bold",
            }}
          />
          <Button
            htmlType="submit"
            icon={<SearchOutlined />}
            style={{
              fontWeight: "bold",
              color: "white",
              backgroundColor: "orangered",

            }}
            size="large"
            loading={searching}
          >
            VERIFICAR
          </Button>
        </div>
      </form>
      <br />
      <Row
        gutter={[16, 16]}
        style={{
          width: "100%",
          padding: 20,
        }}
        justify="center"
      >
        {
          tickets.map(item =>
            <Col
              key={item.id}
              xs={24}
              sm={12}
              md={8}
              lg={6}
            >
              <Card
                styles={{
                  title: {
                    fontSize: 20,
                    fontWeight: "bold"
                  }
                }}
                title={`Boleto: ${item.number.toString().padStart(6, "0")}`}
                style={{ fontSize: 16 }}
              >
                <p><b>Estatus:</b> {item.status}
                  {
                    item.status === "Pagado"
                      ? <CheckCircleOutlined style={{ color: "green" }} />
                      : null
                  }
                </p>
                <p><b>Comprador:</b> {item.buyer}</p>
                <p><b>Celular:</b> {item.phone}</p>
                <p><b>Estado:</b> {item.state}</p>
              </Card>
            </Col>
          )
        }
      </Row>
    </div >
  );
};

export default VerifyTickets;